<ng-container *ngIf="!!compactView; else nonCompactView">
  <ng-template [ngTemplateOutlet]="content"></ng-template>
</ng-container>
<ng-template #nonCompactView>
  <mat-card appearance="outlined" class="package-list-container">
    <mat-card-header>
      <mat-card-title class="title">{{ title | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <ng-template [ngTemplateOutlet]="content"></ng-template>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #content>
  <mat-list>
    <div class="package-list" *ngFor="let package of this.salesPackages; let packageIndex = index; let first = first">
      <sales-ui-sales-order-package-dropdown-item
        [title]="package.name"
        [iconUrl]="package.icon"
        [statusItem]="package.activationStatus"
        [description]="packageDescription(package)"
        [enableDropdown]="package.salesProducts?.length > 0 || package.addonsWithNoParent?.length > 0"
        [toggleValue]="packageToggles[packageIndex]"
        [first]="first"
        [showMenuItems]="showMenuItems"
        (itemToggled)="togglePackage(packageIndex)"
      ></sales-ui-sales-order-package-dropdown-item>

      <mat-list
        class="product-or-addon-list package-dropdown-font"
        *ngIf="packageToggles[packageIndex]"
        [@listAnimationStart]
      >
        <div *ngFor="let product of package.salesProducts">
          <sales-ui-sales-order-package-dropdown-item
            [title]="product.sharedMarketingInformation.name"
            [editionName]="product.sharedMarketingInformation.editionName"
            [previousEditionName]="getPreviousEditionName(product)"
            [iconUrl]="product.sharedMarketingInformation.iconUrl"
            [statusItem]="product.activationStatus"
            [menuItems]="product.menuItems"
            [indent]="packageProductIndent"
            [showMenuItems]="showMenuItems"
            (menuItemClicked)="menuItemClick($event)"
          ></sales-ui-sales-order-package-dropdown-item>

          <sales-ui-sales-order-package-dropdown-item
            *ngFor="let addon of product.addons"
            [title]="addon.sharedMarketingInformation.name"
            [iconUrl]="addon.sharedMarketingInformation.iconUrl"
            [statusItem]="addon.activationStatus"
            [menuItems]="addon.menuItems"
            [indent]="packageAddonWithProductIndent"
            [showMenuItems]="showMenuItems"
            (menuItemClicked)="menuItemClick($event)"
          ></sales-ui-sales-order-package-dropdown-item>
        </div>

        <sales-ui-sales-order-package-dropdown-item
          *ngFor="let addon of package.addonsWithNoParent"
          [title]="addon.sharedMarketingInformation.name"
          [titleDescriptor]="
            'FRONTEND.STORE.REQUIRES_DESCRIPTOR'
              | translate
                : {
                    requirementName: addon.parentRequirements.parentDetails.name
                  }
          "
          [iconUrl]="addon.sharedMarketingInformation.iconUrl"
          [secondaryIconUrl]="addon.parentRequirements.parentDetails.iconUrl"
          [secondaryIconName]="addon.parentRequirements.parentDetails.name"
          [statusItem]="addon.activationStatus"
          [menuItems]="addon.menuItems"
          [indent]="packageAddonWithoutProductIndent"
          [showMenuItems]="showMenuItems"
          (menuItemClicked)="menuItemClick($event)"
        ></sales-ui-sales-order-package-dropdown-item>
      </mat-list>
    </div>

    <div class="product-list" *ngFor="let product of this.salesProducts; let first = first">
      <sales-ui-sales-order-package-dropdown-item
        [first]="first"
        [title]="product.sharedMarketingInformation.name"
        [editionName]="product.sharedMarketingInformation.editionName"
        [previousEditionName]="getPreviousEditionName(product)"
        [titleDescriptor]="standAloneProductWithParentDescription(product)"
        [iconUrl]="product.sharedMarketingInformation.iconUrl"
        [secondaryIconUrl]="product.parentRequirements.enabled ? product.parentRequirements.parentDetails.iconUrl : ''"
        [secondaryIconName]="product.parentRequirements.enabled ? product.parentRequirements.parentDetails.name : ''"
        [statusItem]="product.activationStatus"
        [menuItems]="product.menuItems"
        [showMenuItems]="showMenuItems"
        (menuItemClicked)="menuItemClick($event)"
      ></sales-ui-sales-order-package-dropdown-item>
    </div>
  </mat-list>
</ng-template>
